import { render, staticRenderFns } from "./ModalEditarPermissoes.vue?vue&type=template&id=4b685da5&"
import script from "./ModalEditarPermissoes.vue?vue&type=script&lang=js&"
export * from "./ModalEditarPermissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports